import { render, staticRenderFns } from "./MaintenanceDialDeleteDialogTable.vue?vue&type=template&id=c8064f78&"
import script from "./MaintenanceDialDeleteDialogTable.vue?vue&type=script&lang=js&"
export * from "./MaintenanceDialDeleteDialogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports